import { text } from "stream/consumers";

const mainTheme = {
    listStyle: {
        row: {

        }
    },
    cardStyle: {
        header: {
            backgroundColor: "#E6E6E6",
            fontSize: "12px",
            textDecoration: "none",
            fontWeight: "400"
        },
    },
    tableStyle: {
        header: {
            backgroundColor: "#FFFFFF",
            fontSize: "14px",
            textDecoration: "none",
            fontWeight: "500"
        },
        subHeader: {
            fontStyle: "italic",
            fontSize: "12px",
            backgroundColor: "#FFFFFF"
        },
        row: {
            fontSize: "14px",
            textDecoration: "none",
            fontWeight: "400",
        },
        subRow: {
            fontSize: "14px",
        }
    },
    footer: {
        height: 20,
        maxHeight: 20,
        width: '100%',
        backgroundColor: '#FFFFFF',
        padding: 1.5,
        textAlign: 'center',
        position: "absolute",
        boxShadow: '0 -1px 3px rgba(0, 0, 0, 0.1)',
        flexShrink: 0,
    },
    colors: {
        innoBlack: "#231f20",
        innoGrayD: "#6d6e6e",
        innoGrayL: "#dbd9d0",
        innoGreenL: "#b2bb1e",
        innoGreenD: "#37451d",
        innoGreenY: "#d6de63",
        innoBlue: "#0076c0",
        innoBlueD: "#142f53",
        innoBlueL: "#6db3e0",
        innoRed: "#ee3424",
        innoOrange: "#dc6d26",
        innoOrangeL: "#f89f32",
        innoPurple: "#974499",
        innoYellow: "#fbc90e",
        pie1: "#cf67cb",
        pie2: "#ff476a"
    },
    cell: {
        "style-dailyUsage": "#EBF9FE",
        "style-daysOnHand": "#EBF9FE",
        "style-dailyUsage14": "#F4ECF4",
        "style-daysOnHand14": "#F4ECF4",
        "style-dailyUsage30": "#F7F8E9",
        "style-daysOnHand30": "#F7F8E9",
    }
}

export default mainTheme;